import type { EventOccurrenceViewModel, FunctionViewModel } from '@trinnvis/dabih-api-client';
import type { OrganizationState } from '../../types';
import type { PartnerContactAsUser } from 'src/store/selectors';
import type { TodoItem } from './todo-item';
import { LocalDate } from 'src/utilities/local-date';
import { eventDoneText } from 'src/store/selectors';
import type { SelectDropdownOption } from 'src/library/editors/elements/select-dropdown-option';
import { eventAssigneesText } from '../../eventAssigneesText';
import { checklistProgress } from 'src/store/selectors/events/checklist-progress';
import { t } from 'src/i18n';

export function homePageEventItem(
  e: EventOccurrenceViewModel,
  overdue: boolean,
  organization: OrganizationState,
  employeesAndContacts: SelectDropdownOption[],
  currentUserUuid: string,
  contactsAsUsers: PartnerContactAsUser[],
  employeesShortNamesAndI: { uuid: string; status: string; name: string }[],
  singleUserVersion: boolean,
  functions: FunctionViewModel[],
): TodoItem {
  let done = false;
  let doneAtDisplay = '';
  if (e.doneDate && (e.doneByEmployeeUuid || e.doneByContactPersonUuid)) {
    done = true;
    doneAtDisplay = LocalDate.fromString(e.doneDate).toStringForDisplay();
  }

  let doneText = '';
  if (e.doneDate) {
    doneText = t('content.donePrefix') + eventDoneText(e, employeesAndContacts, singleUserVersion);
  }
  let myTask = true;
  if (!singleUserVersion) {
    myTask = false;
    if (e.functionUuid && organization.functionsById[e.functionUuid]) {
      if (organization.functionsById[e.functionUuid].employees.includes(currentUserUuid)) {
        myTask = true;
      }
    } else {
      if (e.employees?.includes(currentUserUuid)) {
        myTask = true;
      }
      if (e.contacts?.length && e.contacts.includes(currentUserUuid)) {
        myTask = true;
      }
    }
  }

  const assignee = eventAssigneesText(e, functions, employeesShortNamesAndI, contactsAsUsers);

  let href = '/account/' + organization.organizationId + '/' + 318434 + '/eventOccurrences/' + e.uuid;
  if (!e.isConfirmedEntity) {
    href += '?edit';
  }

  return {
    uuid: e.uuid,
    name: e.name,
    href,
    eventNotes: e.notes,
    assignee: singleUserVersion ? '' : assignee,
    myTask: myTask,
    overdue: overdue,
    dateTimeForOrdering: e.date + ' ' + (e.time && e.time !== 'NONE' ? e.time : '00:00'),
    done: done,
    doneDate: e.doneDate ?? '',
    doneAtDisplay: doneAtDisplay,
    doneByEmployeeUuid: e.doneByEmployeeUuid,
    doneText: doneText,
    hasDraft: e.hasDraft,
    isConfirmedEntity: e.isConfirmedEntity,
    draftName: e.draftName ?? '',
    progress: checklistProgress(e.description),
  };
}
